/**
 * CC Mock API Slice
 * Mock implementation using local mock endpoint
 */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { SteConfigResponse } from "./types";

// Mock Base URL
const MOCK_API_BASE_URL = "http://127.0.0.1:3658/m1/1173882-1167811-default";

export const ccMockApi = createApi({
  reducerPath: "ccMockApi",
  baseQuery: fetchBaseQuery({
    baseUrl: MOCK_API_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["Contacts"],
  endpoints: (builder) => ({
    getSteConfig: builder.query<SteConfigResponse, void>({
      query: () => "/ste/config",
      providesTags: ["Contacts"],
    }),
  }),
});

export const { useGetSteConfigQuery: useGetMockSteConfigQuery } = ccMockApi;
